module.exports = __webpack_public_path__ + "img/JAPAN.766c1628.jpeg";